import { render } from "./NavigationItemGroup.vue?vue&type=template&id=dfb844c4&scoped=true"
import script from "./NavigationItemGroup.vue?vue&type=script&lang=js"
export * from "./NavigationItemGroup.vue?vue&type=script&lang=js"

import "./NavigationItemGroup.vue?vue&type=style&index=0&id=dfb844c4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb844c4"]])

export default __exports__